const { createContext } = require("react");

export const CheckContext = createContext();
